/**
 * Nút hệ thống: `variant` (primary / outline / ghost…), `size`, `loading` (spinner + disable).
 * Hỗ trợ `ref` (forwardRef) để gắn vào menu, đo layout, v.v.
 */
import React from 'react';
import { cn } from './cn';
const Button = React.forwardRef(function Button({ variant = 'primary', size = 'md', loading = false, className, disabled, children, ...props }, ref) {
    const baseClasses = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
    const variantClasses = {
        primary: 'bg-primary text-primary-foreground hover:bg-primary/90',
        secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        outline: 'border border-input hover:bg-accent hover:text-accent-foreground',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
    };
    const sizeClasses = {
        sm: 'h-9 px-3 text-sm',
        md: 'h-10 py-2 px-4',
        lg: 'h-11 px-8',
    };
    return (React.createElement("button", { ref: ref, className: cn(baseClasses, variantClasses[variant], sizeClasses[size], className), disabled: disabled || loading, ...props },
        loading && (React.createElement("svg", { className: "mr-2 h-4 w-4 animate-spin", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }),
            React.createElement("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" }))),
        children));
});
Button.displayName = 'Button';
export default Button;
